import React from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { superAdminLinks } from "../../utils/links";
import { userLinks } from "../../utils/links";
import "./Sidebar.css";
import UserNavlinks from "./UserNavlinks";
import queryClient from "../../utils/queryClient";
import LogoutIcon from "@mui/icons-material/Logout";
import API from "../../utils/Axios.utils";

const Navlinks = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const userLoggedIn = JSON.parse(localStorage.getItem("userLoggedIn"));
  const role = userLoggedIn?.role?.toLowerCase();

  const handleLogout = async () => {
    try {
      await API.post("/api/users/logout");
    } catch {
      // logout should never block navigation, even if the audit call fails
    }
    // localStorage.removeItem("userLoggedIn");
    localStorage.clear();
    queryClient.clear();
    navigate("/login");
  };

  if (role === "admin") {
    const mainLinks = superAdminLinks.filter((l) => l.path !== "/settings");
    const settingsLink = superAdminLinks.find((l) => l.path === "/settings");

    return (
      <div className="nav-links">
        <div className="nav-top">
          {mainLinks.map(({ text, path, id, icon }) => (
            <NavLink
              to={path}
              key={id}
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
              onClick={toggleSidebar}
            >
              <div className="icon">{icon}</div>
              {text}
            </NavLink>
          ))}
        </div>

        <div className="nav-bottom">
          <hr className="nav-divider" />
          {settingsLink && (
            <NavLink
              to={settingsLink.path}
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
              onClick={toggleSidebar}
            >
              <div className="icon">{settingsLink.icon}</div>
              {settingsLink.text}
            </NavLink>
          )}
          <button
            style={{ background: "none", border: "none", cursor: "pointer" }}
            className="nav-link"
            onClick={handleLogout}
          >
            <div className="icon"><LogoutIcon /></div>
            Logout
          </button>
        </div>
      </div>
    );
  }
  return (
    <UserNavlinks
      NavLink={NavLink}
      userLinks={userLinks}
      toggleSidebar={toggleSidebar}
      handleLogout={handleLogout}
    />
  );
};

export default Navlinks;
